export * from "./CompanyBusinessRegistration";

import { lazy } from "@loadable/component";
import { Suspense } from "react";
import { ErrorBoundary } from "@sentry/react";
import { Spin } from "antd";
import { ErrorFallback } from "../../patterns";
import { CompanyBusinessRegistrationProps } from "./CompanyBusinessRegistration.types";

export const CompanyBusinessRegistrationLoadable = lazy(
  () => import("./CompanyBusinessRegistration")
);

export const CompanyBusinessRegistration = (props: CompanyBusinessRegistrationProps) => {
  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Suspense
        fallback={
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "200px" }}>
            <Spin size="large" />
          </div>
        }
      >
        <CompanyBusinessRegistrationLoadable {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
